import { render, staticRenderFns } from "./thumbup.vue?vue&type=template&id=1feb5f95&scoped=true&"
var script = {}
import style0 from "./thumbup.vue?vue&type=style&index=0&id=1feb5f95&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1feb5f95",
  null
  
)

export default component.exports